// Classe para gerenciar requisições HTTP
class ApiService {
  constructor() {
    // Base URL da API - pode ser configurada via variáveis de ambiente
    this.baseURL = this.getApiUrl();
  }

  // Método para obter a URL da API com fallback seguro
  getApiUrl() {
    // Para Vite, usa import.meta.env
    const viteApiUrl = import.meta.env.VITE_API_URL;
    if (viteApiUrl) {
      return viteApiUrl;
    }

    // Sempre usar URL absoluta da API externa
    return 'https://api.conexaosaude.org';
  }

  // Método genérico para fazer requisições
  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;

    // Se não há headers definidos em options, usar padrão JSON
    const defaultHeaders = options.headers ? {} : { 'Content-Type': 'application/json' };

    const config = {
      headers: {
        ...defaultHeaders,
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);

      // Verifica se é um redirect
      if (response.redirected) {
        console.warn('Request was redirected to:', response.url);
        throw new Error(`API endpoint redirected. The endpoint ${endpoint} may not be implemented or configured correctly.`);
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Verifica se a resposta tem conteúdo
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return await response.json();
      }

      return { success: true };
    } catch (error) {
      console.error('API Request failed:', error);
      throw error;
    }
  }

  // POST /api/cookie-consent
  async saveCookieConsent(data) {
    return this.request('/api/cookie-consent', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // PUT /api/cookie-consent/{sessionId}
  async updateCookieConsent(sessionId, data) {
    return this.request(`/api/cookie-consent/${sessionId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  // POST /api/cookie-consent/{sessionId}/activity
  async registerUserActivity(sessionId, data) {
    return this.request(`/api/cookie-consent/${sessionId}/activity`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // POST /api/candidatos
  async createCandidato(data, isFormData = false) {
    const options = {
      method: 'POST',
    };

    if (isFormData) {
      // Para FormData, não definir Content-Type (deixar o browser definir)
      // Mas ainda incluir accept e X-CSRF-TOKEN
      options.headers = {
        'accept': 'application/json',
        'X-CSRF-TOKEN': ''
      };
      options.body = data;
    } else {
      // Para JSON
      options.headers = {
        'accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': ''
      };
      options.body = JSON.stringify(data);
    }

    return this.request('/api/candidatos', options);
  }

  async sendContato(data) {
    const options = {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': ''
      },
      body: JSON.stringify(data)
    };

    return this.request('/api/contato', options);
  }
}

// Instância singleton do serviço
const apiService = new ApiService();

export default apiService;
